import React from 'react';
import { ClipboardCheckIcon, HourglassIcon, ListOrderedIcon, NotebookPenIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionBenefits } from '../../data/content';
const icons = [HourglassIcon, ListOrderedIcon, NotebookPenIcon, ClipboardCheckIcon];
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-175" data-mp="1ohpjuwb4dzaq">
      <div className="mx-auto max-w-5xl" data-id="element-176" data-mp="1thln2tbztmp8">
        <SectionHeading id="solution-heading" title={<>
              Meet <Accent data-id="element-178" data-mp="23d5ilemnajdg">PMU Instructor Ready™</Accent>
            </>} body={<>
              <strong className="font-semibold text-brand-charcoal" data-id="element-179" data-mp="27fk11xmejh47">The Complete Permanent Makeup Teaching System.</strong>{' '}
              A practical collection of teaching guides, classroom resources, student exercises, and assessment tools
              designed to help PMU educators organize their courses without building every resource from the ground up.
            </>} data-id="element-177" data-mp="1ye2lcgcwphg1" />

        <ul className="mx-auto mt-14 grid max-w-4xl gap-x-12 gap-y-10 sm:grid-cols-2" role="list" data-id="element-180" data-mp="3s0unb86v17vx">
          {solutionBenefits.map((benefit, index) => {
          const Icon = icons[index];
          return <li key={benefit.title} className="flex items-start gap-4" data-id="element-181" data-mp="3i49c2548z0jn" data-mpi={index}>
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full" style={{
              backgroundColor: benefit.tint
            }} data-id="element-182" data-mp="jlklm16vu4oo">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-183" data-mp="9mbvxkj1vc84" />
                </span>
                <span data-id="element-184" data-mp="4n8q3xv8x1z3">
                  <span className="block font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal" data-id="element-185" data-mp="4q4o1m73fqnj">
                    {benefit.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-186" data-mp="2pdhizgihas0j">
                    {benefit.text}
                  </span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}